export function validateToolFeedback(config = {}) {
  const delay = Number(config.start_delay_seconds ?? 0);
  if (!Number.isFinite(delay) || delay < 0 || delay > 44) return 'Start delay must be between 0 and 44 seconds';
  if (['typing', 'typing_background'].includes(config.start_sound) && delay <= 0) return 'Typing sound requires a positive Start delay';
  const waitsForSpeech = config.delay_till_start_message_spoken === 'Yes' || config.delay_till_start_message_spoken === true;
  if (waitsForSpeech && delay > 0) return 'Set Delay Execution to No when using Start delay';
  if (waitsForSpeech && config.interrupt_start_message_on_result) return 'Set Delay Execution to No when interrupting the start message on tool completion';
  return '';
}
